import React, { Component } from "react";
import PropTypes from "prop-types";
import HotTable from "react-handsontable";
import Handsontable from "handsontable";
import TDialog from "../Dialogs/TDialog";
import {
    GB_SC_Linear,
    GB_SC_SShaped,
    GB_SC_Exponential,
    GB_SC_FrontLoaded,
    GB_SC_Duplicate,
    GB_SC_Normalize,
    GB_SC_Multiply,
    GBDuplicate,
    GBInterpolate,
    GBMultiply,
    GBNormalize,
} from "../NonComponents/GBUtil";

function renderCell(instance, td, row, col, prop, value, cellProperties, renderType, o) {
    switch (renderType) {
        case "Autocomplete":
            Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
            break;
        case "Checkbox":
            Handsontable.renderers.CheckboxRenderer.apply(this, arguments);
            break;
        case "Numeric":
            Handsontable.renderers.NumericRenderer.apply(this, arguments);
            break;
        case "Text":
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            break;
        default:
            break;
    }
}

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function makeid(len) {
    let text = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < len; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

class GBTStdTable extends Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        id: PropTypes.string,
        stretch: PropTypes.bool,
        minHeight: PropTypes.any,
        maxHeight: PropTypes.any,
        width: PropTypes.any,
        bandColor: PropTypes.any,
        fixedRowColor: PropTypes.string,
        rounded: PropTypes.bool,
        highlightColor: PropTypes.string,
        cellPadding: PropTypes.string,
        disableContextMenu: PropTypes.bool,
        style: PropTypes.any,
        onSheetCellsChanged: PropTypes.func,
        onAfterSelectionEnd: PropTypes.func,
    };

    static defaultProps = {
        id: makeid(25),
        stretch: false,
        minHeight: 0,
        maxHeight: "100%",
        width: "100%",
        bandColor: null,
        fixedRowColor: "#efefef",
        rounded: false,
        highlightColor: "#fff1a6",
        cellPadding: "3",
        disableContextMenu: false,
        style: {},
        onSheetCellsChanged: (hot, packTable) => {}, // console.log('onSheetCellsChanged')
        onAfterSelectionEnd: (r, c, r2, c2) => {},
    };

    constructor(props) {
        super(props);

        this.hot = null;
        this.id = this.props.id;
        this.stretch = this.props.stretch;
        this.minHeight = this.props.minHeight;
        this.maxHeight = this.props.maxHeight;
        this.width = this.props.width;
        this.bandColor = this.props.bandColor;

        this.title = "";
        this.mstEditorID = null;

        this.state = {
            dialogTitle: "",
            dialogMessage: "",
            dialogOpen: false,
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.onResize);
        this.hot = this.refs[this.id] ? this.refs[this.id].hotInstance : null;

        this.onResize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.onResize);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        //
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.hot = this.refs[this.id] ? this.refs[this.id].hotInstance : null;
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        let changed = false;
        changed = changed || JSON.stringify(this.props) !== JSON.stringify(nextProps);
        changed = changed || JSON.stringify(this.state) !== JSON.stringify(nextState);

        if (changed) {
            return true;
        } else {
            return false;
        }
    }

    render() {
        // //------------------------------------------------------------
        // //
        // //  Potention Future Fix: Merging old merged cells with new
        // //
        // //------------------------------------------------------------
        // if (this.hot !== null) {
        //     let mergeCells = this.mergeCells();
        //
        //     for (let i = 0; i < this.hot.mergeCells.mergedCellInfoCollection.length; i++){
        //         mergeCells.mergeCells.push(this.hot.mergeCells.mergedCellInfoCollection[i]);
        //     }
        //
        //     this.hot.updateSettings(mergeCells);
        // }

        const getDefaultTable = () => {
            this.settings = {
                mergeCells: true, // HACK: need this if we want to add mergedCells later on
            };
        };

        const getCustomTable = () => {
            this.title = this.props.packTable["Title"];
            this.mstEditorID = this.props.packTable["editorMstID"];

            // The state contains the dialog, packTable and HandsOnTable settings
            this.settings = {
                // Data
                data: this.props.packTable["tableData"]["value"],

                comments: true,
                trimWhitespace: false,
                observeChangesBoolean: true,
                stretchH: "none",
                width: this.width,
                height: this.hot !== null ? this.getTableHeight() : 300,
                fixedRowsTop: this.fixedRows(),
                /* When fixed columns are specified in addition to fixed rows, it causes the
                   rows after the last fixed column not to line up with the rows before the
                   last fixed column (because one of the rows before the last fixed column
                   does not get displayed). Should be possible to do this. Seems to want
                    rowHeaders and colHeaders to be set in examples online, but doing that
                    breaks things.. */
                fixedColumnsLeft: 0, //this.fixedCols(),
                colWidths: this.colWidths,
                contextMenu: this.contextMenu(),
                cells: this.cells,
                cell: this.cell(),
                columns: this.columns(),

                // Events
                beforeChange: this.onBeforeChange,
                afterChange: this.onAfterChange,
                afterInit: this.onAfterInit,
                // afterSelection        : this.onAfterSelection,
                afterSelectionEnd: this.onAfterSelectionEnd,

                // Custom Settings
                mergeCells: this.mergeCells(),
                packTable: this.props.packTable,
                calculateTotalRows: this.calculateTotalRows,
                calculateTotalCols: this.calculateTotalCols,
                SheetCellsChanged: this.SheetCellsChanged,
                onSheetCellsChanged: this.props.onSheetCellsChanged,
                // onAfterSelection      : this.props.onAfterSelection,
                onAfterSelectionEnd: this.props.onAfterSelectionEnd,

                autoRowSize: true,
                //autoColumnSize: true

                //customBorders       : this.customBorders(),                                                           // [2/28/18] TGP Note: THIS SLOWS THINGS DOWN TO HELL
                rowHeights: this.rowHeights,
                //dataSchema          : {{id: null, name: {first: null, last: null}, address: null}}                    // Fake info needed for checkboxes???
                //fixedColumnsLeft    : o["GBFixedCols"],                                                               // Enabling this will mess up any merged cells in the fixed column, something is destroying the cells
            };
        };

        // Show an empty table if packTable does not exist
        if (
            typeof this.props.packTable === "undefined" ||
            this.props.packTable === null ||
            typeof this.props.packTable["tableData"] === "undefined"
        ) {
            getDefaultTable();
        } else {
            getCustomTable();
        }

        return (
            <div style={this.props.style}>
                {/*<div style={{color: '#0e47a1', fontWeight: 'bold', fontSize: '14px'}}>*/}
                {/*{this.title} ({this.mstEditorID})*/}
                {/*</div>*/}

                <HotTable
                    root={this.id}
                    ref={this.id}
                    settings={this.settings}
                />

                <TDialog
                    caption={this.state.dialogTitle}
                    message={this.state.dialogMessage}
                    actions={["mrOK"]}
                    modal={false}
                    visible={this.state.dialogOpen}
                    onClose={this.onContextMenuClose}
                />
            </div>
        );
    }

    //==================================================================================================================
    //
    //                                         HandsOnTable Specific Calls
    //
    //==================================================================================================================

    onBeforeChange(changes, source) {
        /*************************************
         *
         *  Changes contain these field
         *  --------------------------------
         *  let aRow = changes[0][0]
         *  let aCol = changes[0][1];
         *  let oldValue = changes[0][2];
         *  let newValue = changes[0][3];
         *
         *************************************/

        let o = this.getSettings().packTable;

        if (source !== "loadData") {
            for (let i = 0; i <= changes.length - 1; i++) {
                let aRow = changes[i][0];
                let aCol = changes[i][1];
                //let oldValue = changes[i][2];
                let newValue = changes[i][3];

                let cell = this.getCellMeta(aRow, aCol);

                if (cell.type === "dropdown") {
                    if (cell.source.includes(newValue)) {
                        return;
                    } else {
                        changes[i][3] = cell.source[i];
                        return;
                    }
                }

                let min = o["MinAllowedVal"][aRow][aCol];
                let max = o["MaxAllowedVal"][aRow][aCol];

                if (min !== 0 || max !== 0) {
                    let num = parseFloat(newValue);
                    if (isNumeric(num)) {
                        if (num < min || num > max) {
                            alert("Value must be between " + min + " and " + max);
                            changes[i][3] = changes[i][2];
                        } else {
                            changes[i][3] = num;
                        }
                    }
                    // mark :-)
                    else if (o["AllowBlanks"]) {
                        changes[i][3] = "";
                    } else {
                        alert("Value must be a number.");
                        changes[i][3] = changes[i][2];
                    }
                }
            }
        }
    }

    onAfterChange(changes, source) {
        /*************************************
         *
         *  Changes contain these field
         *  --------------------------------
         *  let aRow = changes[0][0]
         *  let aCol = changes[0][1];
         *  let oldValue = changes[0][2];
         *  let newValue = changes[0][3];
         *
         *************************************/

        if (source !== "loadData" && source !== "programatic") {
            // this.getSettings().calculateTotalRows(this);
            // this.getSettings().calculateTotalCols(this);

            if (changes[0][2] !== changes[0][3]) {
                this.getSettings().SheetCellsChanged(this);
            }
        }

        // if (this.props.RecalcGrid != 'undefined') {
        //     this.props.RecalcGrid;
        // }
    }

    onAfterInit() {
        this.getSettings().calculateTotalRows(this);
        this.getSettings().calculateTotalCols(this);
        // this.getSettings().SheetCellsChanged(this);
    }

    // onAfterSelection(r, c, r2, c2, preventScrolling, selectionLayerLevel) {
    //     debugger;
    // 	var data = this.getDataAtRow(r);
    //     this.getSettings().onAfterSelection(r, c, data);
    // }

    onAfterSelectionEnd(r, c, r2, c2) {
        this.getSettings().onAfterSelectionEnd(r, c, r2, c2);
    }

    SheetCellsChanged(hot) {
        hot.getSettings().onSheetCellsChanged(hot, hot.getSettings().packTable);
        hot.getSettings().calculateTotalRows(hot);
        hot.getSettings().calculateTotalCols(hot);
    }

    contextMenu = () => {
        if (this.props.disableContextMenu === true) {
            return null;
        }

        let that = this;

        return {
            callback: function (key, options) {
                let o = that.props.packTable;

                // timeout is used to make sure the menu collapsed before alert is shown

                // if (key === 'about') {
                //     setTimeout(function () {
                //         APP.MODAL.Show('This is a context menu with default and custom options mixed');
                //     }, 100);
                // }
                // else

                switch (key) {
                    case "decrementDecimal": {
                        alert("hi");
                        break;
                    }

                    case "incrementDecimal": {
                        alert("hi");
                        break;
                    }

                    case "duplicate": {
                        let value = that.hot.getDataAtCell(options.start.row, options.start.col);

                        for (let r = options.start.row; r <= options.end.row; r++) {
                            for (let c = options.start.col; c <= options.end.col; c++) {
                                that.hot.setDataAtCell(r, c, value);
                            }
                        }

                        break;
                    }

                    // case 'interpolate' : {
                    //
                    //     let o = that.props.packTable;
                    //     let resValues = [];
                    //     let value;
                    //     let mult = 0;
                    //     let r, c;
                    //     let r1 = options.start.row;
                    //     let r2 = options.end.row;
                    //     let c1 = options.start.col;
                    //     let c2 = options.end.col;
                    //     let pattern = 1;
                    //
                    //     function PushValue(r, c) {
                    //         if (!o.LockedCells[r][c] || (((r = r1) || (r = r2)) && ((c = c1) || (c = c2)))) {
                    //             value = that.hot.getDataAtCell(r, c);
                    //             resValues.push(value);
                    //         }
                    //     }
                    //
                    //     function PopValue(r, c) {
                    //         let oldValue = that.hot.getDataAtCell(r, c);
                    //         let newValue = resValues[resValues.length-1];
                    //
                    //         that.hot.setDataAtCell(r, c, newValue);
                    //
                    //         resValues.pop();
                    //     }
                    //
                    //     if ((r1 <= 0) || (c1 <= 0) || (r2 <= 0) || (c2 <= 0))
                    //         return;
                    //
                    //     /* Evaluate columns (and rows if applicable) */
                    //     if (c1 !== c2) {
                    //         for (r = r1; r <= r2; r++) {
                    //             for (c = c1; c <= c2; c++) {
                    //                 PushValue(r, c);
                    //             }
                    //
                    //             resValues = GBInterpolate(resValues, pattern);
                    //
                    //             for (c = c2; c >= c1; c--) {
                    //                 PopValue(r, c);
                    //             }
                    //         }
                    //     }
                    //
                    //     /* Evaluate rows only */
                    //     else if ((r1 !== r2) && !(c1 !== c2)) {
                    //         for (r = r1; r <= r2; r++) {
                    //             PushValue(r, c1);
                    //         }
                    //
                    //         resValues = GBInterpolate(resValues, pattern);
                    //
                    //         for (r = r2; r >= r1; r--) {
                    //             PopValue(r, c1);
                    //         }
                    //     }
                    //
                    //     /* Evaluate a single cell. */
                    //     else if ((r1 = r2) && (c1 = c2)) {
                    //         PushValue(r1, c1);
                    //         resValues = GBInterpolate(resValues, pattern);
                    //         PopValue(r1, c1);
                    //     }
                    //
                    //     break;
                    // }

                    case "source": {
                        if (typeof o["SourceList"] !== "undefined") {
                            let sources = o["SourceList"].join("<br>");

                            if (sources === "") {
                                sources = "No sources available";
                            }

                            that.setState({
                                dialogOpen: true,
                                dialogTitle: "Sources for this editor",
                                dialogMessage: sources,
                            });
                        } else {
                            console.warn("SourceList is undefined!");
                        }

                        break;
                    }

                    default:
                        break;
                }
            },
            items: {
                undo: { disabled: false },
                redo: { disabled: false },
                hsep1: "---------",
                // 'cut'              : { disabled: false },
                copy: { disabled: false },
                // 'paste'            : { disabled: true },
                hsep2: "---------",
                decrementDecimal: { name: "Decrement Decimal", disabled: true },
                incrementDecimal: { name: "Increment Decimal", disabled: true },
                // "hsep3"            : "---------",
                // "copyAll"          : {name: 'Copy All'},
                hsep4: "---------",
                duplicate: {
                    //name: 'Duplicate',
                    name: function () {
                        return "Duplicate";
                    },
                    callback: function (key, options) {
                        that.sheetInterpolate(key, options, 5);
                    },
                },
                interpolate: {
                    name: "Interpolate",
                    submenu: {
                        items: [
                            {
                                key: "interpolate:Linear",
                                name: function () {
                                    return "Linear";
                                    //return "<i class='fa fa-fw fa-columns'> </i> Linear";
                                },
                                callback: function (key, options) {
                                    that.sheetInterpolate(key, options, 1);
                                },
                            },
                            {
                                key: "interpolate:S-Shaped",
                                name: "S-Shaped",
                                callback: function (key, options) {
                                    that.sheetInterpolate(key, options, 2);
                                },
                            },
                            {
                                key: "interpolate:Exponential",
                                name: "Exponential",
                                callback: function (key, options) {
                                    that.sheetInterpolate(key, options, 3);
                                },
                            },
                            {
                                key: "interpolate:Front loaded",
                                name: "Front loaded",
                                callback: function (key, options) {
                                    that.sheetInterpolate(key, options, 4);
                                },
                            },
                        ],
                    },
                },
                Normalize: {
                    name: function () {
                        return "Normalize";
                    },
                    callback: function (key, options) {
                        that.sheetInterpolate(key, options, 6);
                    },
                },
                Multiply: {
                    name: function () {
                        return "Multiply";
                    },
                    callback: function (key, options) {
                        that.sheetInterpolate(key, options, 7);
                    },
                },
                hsep5: "---------",
                source: { name: "Source", disabled: true },
            },
        };
    };

    onContextMenuClose = () => {
        this.setState({
            dialogOpen: false,
        });
    };

    columns = () => {
        let arr = [];

        for (let i = 0; i < this.props.packTable["GBColCount"]; i++) {
            arr.push({
                wordWrap: true,
            });
        }

        return arr;
    };

    //==================================================================================================================
    //
    //                                                 'cells'
    //
    //==================================================================================================================

    cells = (row, col, prop) => {
        let cellProperties = {};

        cellProperties.renderer = (instance, td, row, col, prop, value, cellProperties) => {
            let o = this.props.packTable;

            let cellInfo = {
                instance: instance,
                td: td,
                row: row,
                col: col,
                prop: prop,
                value: value,
                cellProperties: cellProperties,
                rendered: false,
            };

            cellProperties.className = "";

            this.SetIndentRowText(cellInfo, o);
            this.SetFontSize(cellInfo, o);
            this.SetFontColor(cellInfo, o);
            this.SetBGColor(cellInfo, o);
            this.SetBandColor(cellInfo, o);
            this.SetLockedCells(cellInfo, o);
            this.SetFixedRow(cellInfo, o);
            this.SetFixedCol(cellInfo, o);
            this.SetAlignment(cellInfo, o);
            this.SetNumericFormat(cellInfo, o);

            this.RenderComboBox(cellInfo, o);
            this.RenderCheckBox(cellInfo, o);
            this.RenderNumeric(cellInfo, o);
            this.RenderText(cellInfo, o);

            cellInfo.td.style.padding = this.props.cellPadding;
            // cellInfo.td.style.wordBreak = 'break-word';
            // cellInfo.td.style.wordWrap = 'normal';
            // cellInfo.td.style.maxWidth = '20px'
        };

        return cellProperties;
    };

    SetFontSize = (cellInfo, o) => {
        //td.style.fontSize = (o["FontSizes"][row][col]) + 6 + "px";
        cellInfo.td.style.fontSize = "12px";
    };

    SetFontColor = (cellInfo, o) => {
        if (typeof o["FontColors"] !== "undefined") {
            if (o["FontColors"][cellInfo.row][cellInfo.col] !== -1) {
                cellInfo.td.style.color = this.getDelphiColorToHex(o["FontColors"][cellInfo.row][cellInfo.col]);
            }
        }
    };

    SetBGColor = (cellInfo, o) => {
        if (typeof o["BGColors"] !== "undefined") {
            if (typeof o["BGColorsHex"] !== "undefined") {
                if (o["BGColors"][cellInfo.row][cellInfo.col] !== -1) {
                    cellInfo.td.style.background = o["BGColors"][cellInfo.row][cellInfo.col];
                }
            } else {
                if (o["BGColors"][cellInfo.row][cellInfo.col] !== -1) {
                    cellInfo.td.style.background = this.getDelphiColorToHex(o["BGColors"][cellInfo.row][cellInfo.col]);
                }
            }
        }
    };

    SetBandColor = (cellInfo, o) => {
        if (cellInfo.row % 2 === 0) {
            if (this.bandColor !== null) {
                cellInfo.td.style.background = this.bandColor;
            } else {
                if (typeof o["BandsOn"] !== "undefined") {
                    if (o["BandsOn"]) {
                        cellInfo.td.style.background = this.getDelphiColorToHex(o["BandColor"]);
                    }
                }
            }
        }
    };

    SetLockedCells = (cellInfo, o) => {
        if (cellInfo.row < o["GBRowCount"]) {
            if (typeof o["LockedCells"] !== "undefined") {
                // console.log('row: ' + cellInfo.row + ', col: ' + cellInfo.col);
                // if (cellInfo.row === 32) {
                //     debugger;
                //     console.log('moo');
                // }

                if (o["LockedCells"][cellInfo.row][cellInfo.col]) {
                    cellInfo.td.style.fontWeight = "";
                    cellInfo.td.style.color = "gray";
                    cellInfo.cellProperties.readOnly = true;
                }
            }
        }
    };

    SetFixedRow = (cellInfo, o) => {
        if (typeof o["GBFixedRows"] !== "undefined") {
            // FIXED ROWS - gray color
            if (o["GBFixedRows"] > 0 && cellInfo.row < o["GBFixedRows"]) {
                cellInfo.td.style.background = this.props.fixedRowColor;
                cellInfo.cellProperties.readOnly = true;
            }

            // FIXED ROWS
            if (o["GBFixedRows"] > 0 && cellInfo.row < o["GBFixedRows"]) {
                cellInfo.td.style.fontWeight = "bold";
                cellInfo.td.style.color = "black";
                cellInfo.cellProperties.readOnly = true;
                cellInfo.td.className = "fixedRow";
            }
        }
    };

    SetFixedCol = (cellInfo, o) => {
        if (typeof o["GBFixedCols"] !== "undefined") {
            // FIXED COLS
            if (o["GBFixedCols"] > 0 && cellInfo.col < o["GBFixedCols"]) {
                cellInfo.td.style.fontWeight = "bold";
                cellInfo.td.style.color = "black";
                cellInfo.cellProperties.readOnly = true;
                cellInfo.td.className = "fixedCol";
            }
        }
    };

    SetIndentRowText = (cellInfo, o) => {
        if (typeof o["IndentRowText"] !== "undefined") {
            if (cellInfo.col === 0) {
                if (o["IndentRowText"][cellInfo.row] > 0) {
                    switch (o["IndentRowText"][cellInfo.row]) {
                        case 15:
                            cellInfo.value = "  " + cellInfo.value;
                            break;
                        case 30:
                            cellInfo.value = "    " + cellInfo.value;
                            break;
                        case 45:
                            cellInfo.value = "      " + cellInfo.value;
                            break;
                        case 60:
                            cellInfo.value = "        " + cellInfo.value;
                            break;
                        default:
                            break;
                    }
                }
            }
        }
    };

    SetAlignment = (cellInfo, o) => {
        if (cellInfo.td.className === "fixedCol") {
            cellInfo.cellProperties.className += " htLeft";
        } else if (isNumeric(cellInfo.value)) {
            cellInfo.cellProperties.className += " htRight";
        } else if (cellInfo.value === "-") {
            cellInfo.cellProperties.className += " htCenter";
        } else {
            cellInfo.cellProperties.className += " htLeft";
        }
    };

    SetNumericFormat = (cellInfo, o) => {
        if (typeof o["RDec"] !== "undefined") {
            const decimalPlaces = o["RDec"][cellInfo.row][cellInfo.col];
            const pattern = "0,0" + (decimalPlaces > 0 ? "." + "0".repeat(decimalPlaces) : "");

            cellInfo.cellProperties.numericFormat = {};
            cellInfo.cellProperties.numericFormat.pattern = pattern;
        }
    };

    RenderComboBox = (cellInfo, o) => {
        if (typeof o["ComboBoxCells"] !== "undefined") {
            if (!cellInfo.rendered) {
                if (o["ComboBoxCells"] !== undefined) {
                    for (let i = 1; i <= o["ComboBoxCells"].length; i++) {
                        let obj = o["ComboBoxCells"][i - 1];

                        if (obj.col === cellInfo.col && obj.row === cellInfo.row) {
                            cellInfo.cellProperties.type = "dropdown";
                            cellInfo.cellProperties.source = obj.strings;

                            renderCell(
                                cellInfo.instance,
                                cellInfo.td,
                                cellInfo.row,
                                cellInfo.col,
                                cellInfo.prop,
                                cellInfo.value,
                                cellInfo.cellProperties,
                                "Autocomplete",
                                o
                            );
                            cellInfo.rendered = true;
                        }
                    }
                }
            }
        }
    };

    RenderCheckBox = (cellInfo, o) => {
        // Something to do with datascheme
        if (typeof o["CheckBoxCells"] !== "undefined") {
            if (!cellInfo.rendered) {
                if (o["CheckBoxCells"] !== undefined) {
                    for (let i = 1; i <= o["CheckBoxCells"].length; i++) {
                        let obj = o["CheckBoxCells"][i - 1];

                        if (obj.col === cellInfo.col && obj.row === cellInfo.row) {
                            cellInfo.cellProperties.type = "checkbox";
                            cellInfo.cellProperties.data = "true";
                            cellInfo.cellProperties.allowInvalid = false;
                            //cellProperties.data = true;

                            renderCell(
                                cellInfo.instance,
                                cellInfo.td,
                                cellInfo.row,
                                cellInfo.col,
                                cellInfo.prop,
                                cellInfo.value,
                                cellInfo.cellProperties,
                                "CheckBox",
                                o
                            );
                            cellInfo.appliedRenderer = true;
                        }
                    }
                }
            }
        }
    };

    RenderNumeric = (cellInfo, o) => {
        if (!cellInfo.rendered) {
            if (
                isNumeric(cellInfo.value) &&
                cellInfo.td.className !== "fixedRow" &&
                cellInfo.td.className !== "fixedCol"
            ) {
                renderCell(
                    cellInfo.instance,
                    cellInfo.td,
                    cellInfo.row,
                    cellInfo.col,
                    cellInfo.prop,
                    cellInfo.value,
                    cellInfo.cellProperties,
                    "Numeric",
                    o
                );
                cellInfo.rendered = true;
            }
        }
    };

    RenderText = (cellInfo, o) => {
        if (!cellInfo.rendered) {
            renderCell(
                cellInfo.instance,
                cellInfo.td,
                cellInfo.row,
                cellInfo.col,
                cellInfo.prop,
                cellInfo.value,
                cellInfo.cellProperties,
                "Text",
                o
            );
            cellInfo.rendered = true;
        }
    };

    //==================================================================================================================
    //
    //                                                 'cell'
    //
    //==================================================================================================================

    cell = () => {
        let o = this.props.packTable;

        let cellList = [];
        this.CreateCellObjects(cellList, o);

        this.SetCellRowIDs(cellList, o);
        this.SetCellColIDs(cellList, o);
        this.SetCellIDs(cellList, o); // mark
        this.SetCellAllowColSources(cellList, o);
        this.SetCellAllowRowSources(cellList, o);
        this.SetCellColSources(cellList, o);
        this.SetCellRowSources(cellList, o);
        this.SetCellFormats(cellList, o);
        this.SetComments(cellList, o);
        this.SetWordWrap(cellList, o);

        return cellList;
    };

    CreateCellObjects = (cellsList, o) => {
        let lastRow = o["GBRowCount"] - 1;
        let lastCol = o["GBColCount"] - 1;

        for (let row = 0; row <= lastRow; row++) {
            for (let col = 0; col <= lastCol; col++) {
                let cellObj = {
                    row: row,
                    col: col,
                    className: "",
                    comment: "",
                    format: "",
                    trimWhitespace: false,
                    customData: {
                        //mark
                        //rowID : 0,
                        //colID : 0
                        rowID: [], // array by rowIDType
                        colID: [], // array by colIDType
                        cellID: 0,
                    },
                };

                cellsList.push(cellObj);
            }
        }
    };

    SetCellRowIDs = (cellsList, o) => {
        if (typeof o["RowId"] !== "undefined") {
            for (let i = 1; i <= cellsList.length; i++) {
                const cellObj = cellsList[i - 1];
                const row = cellObj.row;
                const numRowIdTypes = o["RowIds"][row].length;

                for (let j = 1; j <= numRowIdTypes; j++) {
                    cellObj.customData.rowID[j - 1] = o["RowIds"][row][j - 1];
                }
            }
        }
    };

    SetCellColIDs = (cellsList, o) => {
        if (typeof o["ColId"] !== "undefined") {
            for (let i = 1; i <= cellsList.length; i++) {
                const cellObj = cellsList[i - 1];
                const col = cellObj.col;
                const numColIdTypes = o["ColIds"][col].length;

                for (let j = 1; j <= numColIdTypes; j++) {
                    cellObj.customData.colID[j - 1] = o["ColIds"][col][j - 1];
                }
            }
        }
    };

    // mark
    SetCellIDs = (cellsList, o) => {
        if (typeof o["CellIds"] !== "undefined") {
            for (let i = 1; i <= cellsList.length; i++) {
                const cellObj = cellsList[i - 1];
                const row = cellObj.row;
                const col = cellObj.col;

                cellObj.customData.cellID = o["CellIds"][row][col];
            }
        }
    };

    SetCellAllowColSources = (cellsList, o) => {
        if (typeof o["GBAllowColSources"] !== "undefined") {
            for (let i = 1; i <= cellsList.length; i++) {
                let cellObj = cellsList[i - 1];
                let row = cellObj.row;
                let col = cellObj.col;

                if (row === 0) {
                    cellObj.customData.GBAllowColSources = o["GBAllowColSources"][col];
                }
            }
        }
    };

    SetCellAllowRowSources = (cellsList, o) => {
        if (typeof o["GBAllowRowSources"] !== "undefined") {
            for (let i = 1; i <= cellsList.length; i++) {
                let cellObj = cellsList[i - 1];
                //let row = cellObj.row;
                let col = cellObj.col;

                if (col === 0) {
                    cellObj.customData.GBAllowRowSources = o["GBAllowRowSources"][col];
                }
            }
        }
    };

    SetCellColSources = (cellsList, o) => {
        if (typeof o["GBColSources"] !== "undefined") {
            for (let i = 1; i <= cellsList.length; i++) {
                let cellObj = cellsList[i - 1];
                let row = cellObj.row;
                let col = cellObj.col;

                if (row === 0) {
                    cellObj.customData.GBColSources = o["GBColSources"][col];
                }
            }
        }
    };

    SetCellRowSources = (cellsList, o) => {
        if (typeof o["GBRowSources"] !== "undefined") {
            for (let i = 1; i <= cellsList.length; i++) {
                let cellObj = cellsList[i - 1];
                //let row = cellObj.row;
                let col = cellObj.col;

                if (col === 0) {
                    cellObj.customData.GBRowSources = o["GBRowSources"][col];
                }
            }
        }
    };

    SetCellFormats = (cellsList, o) => {
        if (typeof o["RDec"] !== "undefined") {
            for (let i = 1; i <= cellsList.length; i++) {
                let cellObj = cellsList[i - 1];
                let row = cellObj.row;
                let col = cellObj.col;

                let rDecFormat = "";
                for (let j = 0; j < o["RDec"][row][col]; j++) {
                    rDecFormat += "0";
                }

                if (rDecFormat === "") {
                    cellObj.format = "0,0";
                } else {
                    cellObj.format = "0,0.[" + rDecFormat + "]";
                }
            }
        }
    };

    SetComments = (cellsList, o) => {
        if (typeof o["GBCellComment"] !== "undefined") {
            for (let i = 1; i <= cellsList.length; i++) {
                let cellObj = cellsList[i - 1];
                let row = cellObj.row;
                let col = cellObj.col;

                cellObj.comment = o["GBCellComment"][row][col];
                if (!o["GBUseTriangle"][row][col]) {
                    cellObj.className += " htHideComment";
                }
            }
        }
    };

    SetWordWrap = (cellsList, o) => {
        if (typeof o["WordWrappedCols"] !== "undefined") {
            for (let i = 1; i <= cellsList.length; i++) {
                let cellObj = cellsList[i - 1];
                //let row = cellObj.row;
                let col = cellObj.col;

                // WORD WRAP
                if (!o["WordWrappedCols"][col]) {
                    cellObj.className += " htNoWrap";
                }
            }
        }
    };

    //==================================================================================================================
    //
    //                                           Other miscellaneous settings
    //
    //==================================================================================================================

    mergeCells = () => {
        let o = this.props.packTable;

        if (typeof o["MergedCells"] !== "undefined") {
            let mergeCells = [];

            for (let i = 0; i < o["MergedCells"].length; i++) {
                mergeCells.push({
                    row: o["MergedCells"][i]["startRow"],
                    col: o["MergedCells"][i]["startCol"],
                    rowspan: o["MergedCells"][i]["numRows"],
                    colspan: o["MergedCells"][i]["numCols"],
                });
            }

            return mergeCells;
        } else {
            return undefined;
        }
    };

    colWidths = (c) => {
        let o = this.props.packTable;

        if (typeof o["GBColWidths"] !== "undefined") {
            // ISSUE: Can't auto size columns as well as setting specific col widths
            // https://github.com/handsontable/handsontable/issues/4122

            let n;

            // Column maximum according to ColWidth
            if (o["GBColWidths"][c] > -1) {
                if (o["GBColWidths"][c] === 0) {
                    return 0.1;
                } else {
                    return o["GBColWidths"][c];
                }
            } else {
                // Column character maximum according to the current data
                let characters_1 = 0;
                for (let r = 0; r <= o["GBRowCount"] - 1; r++) {
                    //try {
                    let n = o["tableData"]["value"][r][c].length;

                    if (n > characters_1) {
                        characters_1 = n;
                    }
                    //}
                    //catch (e) {
                    //    //alert('moo');
                    //}
                }

                // Column character maximum according to left and right decimal
                let characters_2 = 0;
                for (let r = 0; r <= o["GBRowCount"] - 1; r++) {
                    n = o["LDec"][r][c] + o["RDec"][r][c];

                    if (o["RDec"][r][c] > 0) {
                        // Decimal point
                        n += 1;
                    }

                    if (o["LDec"][r][c] > 15) {
                        // thousands serperator
                        n += 5;
                    } else if (o["LDec"][r][c] > 12) {
                        n += 4;
                    } else if (o["LDec"][r][c] > 9) {
                        n += 3;
                    } else if (o["LDec"][r][c] > 6) {
                        n += 2;
                    } else if (o["LDec"][r][c] > 3) {
                        n += 1;
                    }

                    if (n > characters_2) {
                        characters_2 = n;
                    }
                }

                // Return
                if (characters_1 > characters_2) {
                    characters_1 = characters_1 + 1; // extra buffer space
                    return characters_1 * 9;
                } else {
                    return characters_2 * 9;
                }
            }
        } else {
            return undefined;
        }
    };

    rowHeights = (r) => {
        let o = this.props.packTable;

        if (typeof o["GBRowHeights"] !== "undefined") {
            // if (r === 0) { return }

            if (o["GBRowHeights"][r] > -1) {
                if (o["GBRowHeights"][r] === 0) {
                    return 0.1;
                } else {
                    return o["GBRowHeights"][r];
                }
            } else {
                return undefined;
            }
        } else {
            return undefined;
        }
    };

    fixedRows = () => {
        let o = this.props.packTable;

        return o["GBFixedRows"];
    };

    fixedCols = () => {
        let o = this.props.packTable;

        return o["GBFixedCols"];
    };

    calculateTotalRows(hot) {
        // dont use setDataAtCell, use loadData instead
        // https://github.com/handsontable/handsontable/issues/1061
        // Do not use this.hot.getData() because we want to manipulate the packTable directly with React.
        let o = hot.getSettings().packTable;

        if (typeof o["TotalRow"] !== "undefined") {
            let lastRow = hot.countRows() - 1;
            let lastCol = hot.countCols() - 1;

            // Calculate Total Row
            if (o["TotalRow"] > 0) {
                let val = "";
                let data = o["tableData"]["value"]; //this.hot.getData();
                for (let c = o["GBFixedCols"]; c <= lastCol; c++) {
                    let sum = 0;
                    for (let r = o["GBFixedRows"]; r <= lastRow - 1; r++) {
                        val = hot.getDataAtCell(r, c);
                        if (isNumeric(val)) {
                            sum += parseFloat(val);
                        }
                    }
                    data[o["TotalRow"]][c] = sum;
                    data[o["TotalRow"]][0] = "Total";
                    //o["tableData"]["value"][o["TotalRow"]][c] = sum;
                }
                hot.loadData(data);
            }
        }
    }

    calculateTotalCols(hot) {
        // dont use setDataAtCell
        // use loadData instead
        // https://github.com/handsontable/handsontable/issues/1061
        // Do not use this.hot.getData() because we want to manipulate the packTable directly with React.
        let o = hot.getSettings().packTable;

        if (typeof o["TotalCol"] !== "undefined") {
            let lastRow = hot.countRows() - 1;
            let lastCol = hot.countCols() - 1;

            // Calculate Total Col
            if (o["TotalCol"] > 0) {
                let val = "";
                let data = o["tableData"]["value"];
                for (let r = o["GBFixedRows"]; r <= lastRow; r++) {
                    let sum = 0;
                    for (let c = o["GBFixedCols"]; c <= lastCol - 1; c++) {
                        val = hot.getDataAtCell(r, c);
                        if (isNumeric(val)) {
                            sum += parseFloat(val);
                        }
                    }

                    data[r][o["TotalCol"]] = sum;
                    //o["tableData"]["value"][r][o["TotalCol"]] = sum;
                }
                hot.loadData(data);
            }
        }
    }

    sheetNormalize = (key, options, pattern) => {
        let that = this;

        let o = that.props.packTable;
        let resValues = [];
        let value;
        let r, c;
        let r1 = options.start.row;
        let r2 = options.end.row;
        let c1 = options.start.col;
        let c2 = options.end.col;

        function PushValue(r, c) {
            if (!o["LockedCells"][r][c] || (((r = r1) || (r = r2)) && ((c = c1) || (c = c2)))) {
                value = that.hot.getDataAtCell(r, c);
                resValues.push(value);
            }
        }

        function PopValue(r, c) {
            let oldValue = that.hot.getDataAtCell(r, c);
            let newValue = resValues[resValues.length - 1];

            if (oldValue !== newValue) {
                that.hot.setDataAtCell(r, c, newValue);
            }

            resValues.pop();
        }

        if (r1 <= 0 || c1 <= 0 || r2 <= 0 || c2 <= 0) return;

        /* Evaluate columns (and rows if applicable) */
        if (c1 !== c2) {
            for (r = r1; r <= r2; r++) {
                for (c = c1; c <= c2; c++) {
                    PushValue(r, c);
                }

                resValues = GBInterpolate(resValues, pattern);

                for (c = c2; c >= c1; c--) {
                    PopValue(r, c);
                }
            }
        } else if (r1 !== r2 && !(c1 !== c2)) {

        /* Evaluate rows only */
            for (r = r1; r <= r2; r++) {
                PushValue(r, c1);
            }

            resValues = GBInterpolate(resValues, pattern);

            for (r = r2; r >= r1; r--) {
                PopValue(r, c1);
            }
        } else if (

        /* Evaluate a single cell. */
            (r1 = r2) &&
            (c1 = c2)
        ) {
            PushValue(r1, c1);
            resValues = GBInterpolate(resValues, pattern);
            PopValue(r1, c1);
        }
    };

    sheetInterpolate = (key, options, pattern) => {
        let that = this;

        let o = that.props.packTable;
        let resValues = [];
        let value;
        let mult = 2;
        let r, c;
        let r1 = options.start.row;
        let r2 = options.end.row;
        let c1 = options.start.col;
        let c2 = options.end.col;

        function PushValue(r, c) {
            if (!o.LockedCells[r][c] || (((r = r1) || (r = r2)) && ((c = c1) || (c = c2)))) {
                value = that.hot.getDataAtCell(r, c);
                resValues.push(value);
            }
        }

        function PopValue(r, c) {
            let oldValue = that.hot.getDataAtCell(r, c);
            let newValue = resValues[resValues.length - 1];

            if (oldValue !== newValue) {
                that.hot.setDataAtCell(r, c, newValue);
            }

            resValues.pop();
        }

        if (r1 <= 0 || c1 <= 0 || r2 <= 0 || c2 <= 0) {
            return;
        }

        /* Evaluate columns (and rows if applicable) */
        if (c1 !== c2) {
            for (r = r1; r <= r2; r++) {
                for (c = c1; c <= c2; c++) {
                    PushValue(r, c);
                }

                switch (pattern) {
                    case GB_SC_Linear:
                        resValues = GBInterpolate(resValues, pattern);
                        break;
                    case GB_SC_SShaped:
                        resValues = GBInterpolate(resValues, pattern);
                        break;
                    case GB_SC_Exponential:
                        resValues = GBInterpolate(resValues, pattern);
                        break;
                    case GB_SC_FrontLoaded:
                        resValues = GBInterpolate(resValues, pattern);
                        break;
                    case GB_SC_Duplicate:
                        resValues = GBDuplicate(resValues);
                        break;
                    case GB_SC_Normalize:
                        resValues = GBNormalize(resValues);
                        break;
                    case GB_SC_Multiply:
                        resValues = GBMultiply(resValues, mult);
                        break;
                    default:
                        break;
                }

                for (c = c2; c >= c1; c--) {
                    PopValue(r, c);
                }
            }
        } else if (r1 !== r2 && !(c1 !== c2)) {

        /* Evaluate rows only */
            for (r = r1; r <= r2; r++) {
                PushValue(r, c1);
            }

            switch (pattern) {
                case GB_SC_Linear:
                    resValues = GBInterpolate(resValues, pattern);
                    break;
                case GB_SC_SShaped:
                    resValues = GBInterpolate(resValues, pattern);
                    break;
                case GB_SC_Exponential:
                    resValues = GBInterpolate(resValues, pattern);
                    break;
                case GB_SC_FrontLoaded:
                    resValues = GBInterpolate(resValues, pattern);
                    break;
                case GB_SC_Duplicate:
                    resValues = GBDuplicate(resValues);
                    break;
                case GB_SC_Normalize:
                    resValues = GBNormalize(resValues);
                    break;
                case GB_SC_Multiply:
                    resValues = GBMultiply(resValues, 2);
                    break;
                default:
                    break;
            }

            for (r = r2; r >= r1; r--) {
                PopValue(r, c1);
            }
        } else if (

        /* Evaluate a single cell. */
            (r1 = r2) &&
            (c1 = c2)
        ) {
            PushValue(r1, c1);

            switch (pattern) {
                case GB_SC_Linear:
                    resValues = GBInterpolate(resValues, pattern);
                    break;
                case GB_SC_SShaped:
                    resValues = GBInterpolate(resValues, pattern);
                    break;
                case GB_SC_Exponential:
                    resValues = GBInterpolate(resValues, pattern);
                    break;
                case GB_SC_FrontLoaded:
                    resValues = GBInterpolate(resValues, pattern);
                    break;
                case GB_SC_Duplicate:
                    resValues = GBDuplicate(resValues);
                    break;
                case GB_SC_Normalize:
                    resValues = GBNormalize(resValues);
                    break;
                case GB_SC_Multiply:
                    resValues = GBMultiply(resValues, 2);
                    break;
                default:
                    break;
            }

            PopValue(r1, c1);
        }
    };

    sheetMultiply = (key, options, pattern) => {
        let that = this;

        let o = that.props.packTable;
        let resValues = [];
        let value;
        let mult = 2;
        let r, c;
        let r1 = options.start.row;
        let r2 = options.end.row;
        let c1 = options.start.col;
        let c2 = options.end.col;

        function PushValue(r, c) {
            if (!o.LockedCells[r][c] || (((r = r1) || (r = r2)) && ((c = c1) || (c = c2)))) {
                value = that.hot.getDataAtCell(r, c);
                resValues.push(value);
            }
        }

        function PopValue(r, c) {
            let oldValue = that.hot.getDataAtCell(r, c);
            let newValue = resValues[resValues.length - 1];

            if (oldValue !== newValue) {
                that.hot.setDataAtCell(r, c, newValue);
            }

            resValues.pop();
        }

        if (r1 <= 0 || c1 <= 0 || r2 <= 0 || c2 <= 0) return;

        /* Evaluate columns (and rows if applicable) */
        if (c1 !== c2) {
            for (r = r1; r <= r2; r++) {
                for (c = c1; c <= c2; c++) {
                    PushValue(r, c);
                }

                resValues = GBMultiply(resValues, mult);

                for (c = c2; c >= c1; c--) {
                    PopValue(r, c);
                }
            }
        } else if (r1 !== r2 && !(c1 !== c2)) {

        /* Evaluate rows only */
            for (r = r1; r <= r2; r++) {
                PushValue(r, c1);
            }

            resValues = GBMultiply(resValues, 2);

            for (r = r2; r >= r1; r--) {
                PopValue(r, c1);
            }
        } else if (

        /* Evaluate a single cell. */
            (r1 = r2) &&
            (c1 = c2)
        ) {
            PushValue(r1, c1);
            resValues = GBMultiply(resValues, 2);
            PopValue(r1, c1);
        }
    };

    //==================================================================================================================
    //
    //                                             'customBorders'
    //
    //     [2/28/18 TGP] This slows the table rendering down to a CRAWL.  Avoid using this setting when possible.
    //
    //==================================================================================================================

    customBorders = () => {
        let o = this.props.packTable;

        let customBorders = [];

        let lastRow = o["GBRowCount"] - 1;
        let lastCol = o["GBColCount"] - 1;

        // BORDERS
        for (let row = 0; row <= lastRow; row++) {
            for (let col = 0; col <= lastCol; col++) {
                if (o["BorderColor"][row][col] !== -1) {
                    customBorders.push({
                        row: row,
                        col: col,
                        top: {
                            width: 1,
                            color: "silver",
                        },
                        right: {
                            width: 1,
                            color: "silver",
                        },
                        bottom: {
                            width: 1,
                            color: "silver",
                        },
                        left: {
                            width: 1,
                            color: "silver",
                        },
                    });
                }
            }
        }

        return customBorders;
    };

    //==================================================================================================================
    //
    //                                                  OTHER
    //
    //==================================================================================================================

    getDelphiColorToHex = (color) => {
        if (color >= 0) {
            let hexString = color.toString(16);

            let R = hexString.slice(-2);
            let G = hexString.slice(-4, -2);
            let B = hexString.slice(-6, -4);

            return "#" + (R + G + B);
        } else {
            return "";
        }
    };

    getTableHeight = () => {
        if (this.hot === null) {
            return undefined;
        }

        if (this.hot.rootElement === null) {
            return undefined;
        }

        let div = this.hot.rootElement;
        let height = window.innerHeight - div.offsetTop;

        // 1) Stretch the chart to the very bottom?
        if (this.stretch) {
            if (this.hot !== null) {
                return height;
            }
        }

        // 2) Or use a custom min/max height
        let minHeight = this.minHeight;
        let maxHeight = this.maxHeight;

        if (height > minHeight && height < maxHeight) {
            return height;
        } else if (height < minHeight) {
            return minHeight;
        } else if (height > maxHeight) {
            return maxHeight;
        } else {
            return undefined;
        }
    };

    onResize = () => {
        this.setState({
            settings: {
                height: this.getTableHeight(),
            },
        });
    };

    GetSSData = () => {
        let r, c;
        let val = "";
        let lastRow = this.hot.countRows() - 1;
        let lastCol = this.hot.countCols() - 1;

        for (r = 0; r <= lastRow; r++) {
            for (c = 0; c <= lastCol; c++) {
                val = this.hot.getDataAtCell(r, c);
                if (isNumeric(val)) {
                    this.props.packTable["tableData"]["value"][r][c] = parseFloat(val);
                } else {
                    this.props.packTable["tableData"]["value"][r][c] = val;
                }
            }
        }
    };
}

export default GBTStdTable;
